import store from "@/store";

let previous;
let revision = 0;
const preferences = new Map();
const listeners = new Set();

// Identificatore opaco: token e dati utente non vengono salvati nelle preferenze.
export const getDsContext = () => {
	const state = store.getState();
	const current = [state.isLoggedIn, state.token, state.user, state.season?.id];
	if (!previous || current.some((value, i) => value !== previous[i])) {
		previous = current;
		revision += 1;
		preferences.clear();
		listeners.forEach((listener) => listener());
	}
	return revision;
};

store.subscribe(getDsContext);
getDsContext();

export const isDsContextReady = () => {
	const state = store.getState();
	return !!(
		state.isLoggedIn &&
		state.token &&
		state.user?.clubId &&
		state.season?.id
	);
};

export const readDsPreference = (key, fallback = null) => {
	getDsContext();
	return preferences.has(key) ? preferences.get(key) : fallback;
};

export const writeDsPreference = (key, value) => {
	getDsContext();
	preferences.set(key, value);
};

export const assertDsContext = (context) => {
	if (context !== getDsContext() || !isDsContextReady()) {
		throw new Error("Contesto DS non più attivo");
	}
};

export const dsOptional = (request, fallback) =>
	request.catch((error) => {
		if (error?.response?.status === 404) return fallback;
		throw error;
	});

export const onDsContextChange = (listener) => {
	listeners.add(listener);
	return () => listeners.delete(listener);
};
